/**
 * Tiện ích bảo vệ hình ảnh khỏi việc lưu và sao chép
 */

// Vô hiệu hóa menu chuột phải cho toàn bộ trang
export const disableRightClick = () => {
  document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG' || 
        e.target.classList.contains('protected-image') || 
        e.target.classList.contains('protected-image-container')) {
      e.preventDefault();
      return false;
    }
  });
};

// Vô hiệu hóa phím tắt của trình duyệt liên quan đến lưu hình ảnh
export const disableBrowserImageSaveShortcuts = () => {
  document.addEventListener('keydown', (e) => {
    // Ctrl+S, Ctrl+U, Ctrl+Shift+I, F12, PrintScreen
    if ((e.ctrlKey && (e.key === 's' || e.key === 'S' || e.key === 'u' || e.key === 'U')) || 
        (e.ctrlKey && e.shiftKey && (e.key === 'i' || e.key === 'I')) || 
        e.key === 'F12' || 
        e.key === 'PrintScreen') {
      const activeElement = document.activeElement;
      const tagName = activeElement.tagName.toLowerCase();
      
      // Không can thiệp nếu người dùng đang nhập trong input hoặc textarea
      if (tagName === 'input' || tagName === 'textarea') {
        return true;
      }
      
      e.preventDefault();
      return false;
    }
  });
};

// Vô hiệu hóa kéo hình ảnh
export const disableImageDrag = () => {
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG' || 
        e.target.classList.contains('protected-image') ||
        e.target.classList.contains('protected-image-container')) {
      e.preventDefault();
      return false;
    }
  });
};

// Ngăn chặn trình duyệt hiển thị menu "Lưu ảnh"
export const preventSaveImageAs = () => {
  document.addEventListener('mousedown', (e) => {
    if (e.target.tagName === 'IMG' || 
        e.target.classList.contains('protected-image')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  });
};

// Hàm khởi tạo tất cả các biện pháp bảo vệ
export const initImageProtection = () => {
  // Khởi tạo tất cả biện pháp bảo vệ khi DOM đã sẵn sàng
  document.addEventListener('DOMContentLoaded', () => {
    disableRightClick();
    disableBrowserImageSaveShortcuts();
    disableImageDrag();
    preventSaveImageAs();
    
    console.log('Image protection initialized');
  });
};
